import React from "react";
import { FormattedMessage } from "react-intl";
import type { Integration } from "src/integrations/objects/Integration";
import type { IntegrationType as IntegrationTypeDef } from "src/integrations/objects/IntegrationType";
import {
  INTEGRATIONS,
  type IntegrationConfig,
} from "src/integrations/views/Integrations";
import {
  type IRaangeLabelWithFAProps,
  RaangeLabel,
} from "src/shared/components/RaangeLabel";
import { BooleanStatusFormatter } from "src/shared/formatters/BooleanStatusFormatter";
import { Formatter } from "src/shared/formatters/Formatter";

export type IntegrationLabelProps = IRaangeLabelWithFAProps;

export interface IntegrationFormatterProps {
  children: Integration;
}

export const IntegrationsLabel = (props: IntegrationLabelProps) => {
  return (
    <RaangeLabel fa="list-alt" {...props}>
      <FormattedMessage id="integrations" />
    </RaangeLabel>
  );
};

export const IntegrationCreate = (props: IntegrationLabelProps) => {
  return (
    <RaangeLabel fa="plus" {...props}>
      <FormattedMessage id="integrations.create" />
    </RaangeLabel>
  );
};

export const IntegrationEdit = (props: IntegrationLabelProps) => {
  return (
    <RaangeLabel fa="pencil-alt" {...props}>
      <FormattedMessage id="integrations.edit" />
    </RaangeLabel>
  );
};

export const IntegrationStatus = ({ children }: IntegrationFormatterProps) => {
  return (
    <BooleanStatusFormatter
      inactiveText={<FormattedMessage id="integrations.deactivated" />}
    >
      {children.integrationStatus}
    </BooleanStatusFormatter>
  );
};

export const IntegrationType = ({ children }: IntegrationFormatterProps) => {
  const integration: IntegrationConfig | undefined =
    INTEGRATIONS[children.integrationType.toUpperCase() as IntegrationTypeDef];
  return <Formatter>{integration?.label ?? null}</Formatter>;
};
